import actions from '../../actionTypes';

export default triggerId => {
  return {
    type: actions.GET_ACTIONS,
    triggerId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/actions/getActions.js